import axios from "axios";

export const getSolutions = async () => {

  const url = process.env.REACT_APP_BASE_LINK + "/api/solutions/?populate=*";

  return await axios
    .get(url)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getSingleSolution = async (index) => {
  try {
    const url =
      process.env.REACT_APP_BASE_LINK +
      `/api/solutions/${index}?populate[0]=attributes&populate[1]=img&populate[2]=metrics.metrics_icon&populate[3]=solutionstepdetails&populate[4]=chart_img`;

    const response = await axios.get(url);
    return response.data.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};